/* Små skript som körs på alla sidor (laddas med defer längst ner i layout/theme.liquid).
   1. Svenska etiketter för temats Flickity-sliders
   2. Tabeller i text från redigeraren scrollar i sidled
   3. Klaviyo onsite, laddas vid idle eller första interaktion
   4. Chatway, samma mönster (inte på bloggen: data-chatway="false" på script-taggen) */
(function () {
  var me = document.currentScript;

  /* ---- 1. Sliderns etiketter ----
     Flickity (i assets/superstore.js) sätter engelska aria-label: "Previous",
     "Next" och "Page dot N". De byts till "Föregående", "Nästa" och "Bild N" vid
     sidladdning och för sliders som skapas senare. Flickity sätter etiketten innan
     elementet läggs in, så det räcker att bevaka tillagda noder (NVObserve). */
  (function () {
    if (window.__nvSliderA11y) return;
    window.__nvSliderA11y = true;

    var SEL = '.flickity-prev-next-button, .flickity-page-dots, .flickity-page-dots .dot';

    function setLabel(el, label) {
      if (el.getAttribute('aria-label') !== label) el.setAttribute('aria-label', label);
    }

    function relabel(root) {
      if (!root || !root.querySelectorAll) return;
      root.querySelectorAll('.flickity-prev-next-button').forEach(function (btn) {
        if (btn.classList.contains('previous')) setLabel(btn, 'Föregående');
        else if (btn.classList.contains('next')) setLabel(btn, 'Nästa');
      });
      root.querySelectorAll('.flickity-page-dots .dot').forEach(function (dot) {
        var m = /^Page dot (\d+)$/.exec(dot.getAttribute('aria-label') || '');
        if (m) setLabel(dot, 'Bild ' + m[1]);
      });
    }

    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      (window.requestAnimationFrame || window.setTimeout)(function () {
        queued = false;
        relabel(document);
      });
    }

    relabel(document);
    if (window.NVObserve) {
      window.NVObserve(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.matches(SEL) || n.querySelector(SEL)) { schedule(); return; }
          }
        }
      });
    }
    window.addEventListener('load', function () { relabel(document); });
  })();

  /* ---- 2. Tabeller i text från redigeraren ----
     Tabellen läggs i en ruta som scrollar i sidled. Då kan själva tabellen vara
     full bredd, och blir den bredare än sidan scrollar rutan i stället för att
     texten trycks ihop. Stilen finns i theme.css, sektion 129. */
  (function () {
    document.querySelectorAll('.rte table:not([class])').forEach(function (t) {
      if (t.parentElement && t.parentElement.classList.contains('nv-table-scroll')) return;
      var box = document.createElement('div');
      box.className = 'nv-table-scroll';
      // Går att scrolla med tangentbordet och nås som ett namngivet område
      box.tabIndex = 0;
      box.setAttribute('role', 'region');
      box.setAttribute('aria-label', 'Tabell');
      t.parentNode.insertBefore(box, t);
      box.appendChild(t);
    });
  })();

  /* ---- 3. Klaviyo onsite ----
     Ersätter Klaviyos app embed (stäng av "Klaviyo onsite" under Tema > Anpassa >
     App embeds, annars laddas skriptet två gånger). Kö-shimmen för klaviyo.push
     ligger kvar direkt i layouten. Startar först när en förrenderad sida visas.
     Laddas alltid, oavsett cookieval (Simons beslut 6 okt 2026). */
  (function () {
    var LOADED_FLAG = '__nv_klaviyo_loaded__';
    var KLAVIYO_SRC = 'https://static.klaviyo.com/onsite/js/YjfnSV/klaviyo.js?company_id=YjfnSV';

    function insert() {
      if (window[LOADED_FLAG]) return;
      window[LOADED_FLAG] = true;
      if (document.querySelector('script[src*="static.klaviyo.com/onsite/js/"]')) return;

      var s = document.createElement('script');
      s.src = KLAVIYO_SRC;
      s.async = true;
      (document.body || document.documentElement).appendChild(s);
    }

    function loadKlaviyo() {
      window.nvNarAktiv(function () {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(insert, { timeout: 2500 });
        } else {
          setTimeout(insert, 1200);
        }
      });
    }

    ['scroll', 'touchstart', 'keydown', 'click', 'mousemove'].forEach(function (evt) {
      window.addEventListener(evt, loadKlaviyo, { once: true, passive: true });
    });

    setTimeout(loadKlaviyo, 6000);
  })();

  /* ---- 4. Chatway ---- */
  (function () {
    if (me && me.getAttribute('data-chatway') === 'false') return;
    var LOADED_FLAG = '__chatway_loaded__';
    var CHATWAY_ID = 'chatway';
    var CHATWAY_SRC = 'https://cdn.chatway.app/widget.js?id=y13o8PFiGadC';

    function insert() {
      if (window[LOADED_FLAG]) return;
      window[LOADED_FLAG] = true;
      if (document.getElementById(CHATWAY_ID)) return;

      var s = document.createElement('script');
      s.id = CHATWAY_ID;
      s.src = CHATWAY_SRC;
      s.async = true;
      (document.body || document.documentElement).appendChild(s);
    }

    function loadChatway() {
      window.nvNarAktiv(function () {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(insert, { timeout: 3000 });
        } else {
          setTimeout(insert, 1200);
        }
      });
    }

    ['scroll', 'touchstart', 'keydown', 'click'].forEach(function (evt) {
      window.addEventListener(evt, loadChatway, { once: true, passive: true });
    });

    setTimeout(loadChatway, 12000);
  })();
})();
